import axios from 'axios'

import { MILES_SERVER_V2_URL } from '@src/configs/env'

// Create axios instance with proper configuration
export const milesApiV2 = axios.create({
    baseURL: MILES_SERVER_V2_URL,
    timeout: 10000,
    withCredentials: false, // Changed to false for CORS
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

// Add response interceptor for better error handling
milesApiV2.interceptors.response.use(
    response => response,
    error => {
        if (error.code === 'ERR_NETWORK') {
            console.error('Network error:', error.config?.url)
        }
        return Promise.reject(error)
    }
)

// Add request interceptor to handle preflight
milesApiV2.interceptors.request.use(
    config => {
        // Remove withCredentials for preflight requests
        if (config.method?.toLowerCase() === 'options') {
            config.withCredentials = false
        }
        return config
    },
    error => Promise.reject(error)
)
